import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

if (!import.meta.env.DEV) {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
}

// Persister les IDs d'affiliation depuis l'URL de redirection
const urlParams = new URLSearchParams(window.location.search);
const aecid = urlParams.get('aecid') || urlParams.get('clickId');
if (aecid) {
  sessionStorage.setItem('affilae_clickId', aecid);
}
const affiliateId = urlParams.get('affiliateTrackingId') || urlParams.get('ae');
if (affiliateId) {
  sessionStorage.setItem('affiliateTrackingId', affiliateId);
}

const sendHeight = () => {
  const root = document.getElementById('root')
  if (!root) return
  // Réinitialise la hauteur avant de mesurer pour permettre la réduction
  document.body.style.height = 'auto'
  document.documentElement.style.height = 'auto'
  window.parent.postMessage({ type: 'resize', height: root.offsetHeight }, '*')
}

window.addEventListener('load', sendHeight)
new ResizeObserver(sendHeight).observe(document.getElementById('root') ?? document.body)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)